import { Grid } from '@material-ui/core';
import { darken } from 'polished';
import styled, { css } from 'styled-components';

import newProductIlustration from '../../../../../assets/newProductIlustration.svg';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/Select';

interface QuantidadeProps {
  isErrored: boolean;
}

interface DisponibilidadeProps {
  isInvisible: boolean;
}

interface FlavorButtonProps {
  isActive: boolean;
}

export const FlavorButton = styled.button<FlavorButtonProps>`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: none;
  outline: none;
  background-color: ${({ isActive }) => (isActive ? '#2979ff' : '#F7F7F7')};
  transition: all 0.2s;

  span {
    color: ${({ isActive }) => (isActive ? '#FFFFFF' : '#212121')};
  }

  & + & {
    margin-left: 10px;
  }

  &:hover {
    box-shadow: 0px 2px 6px rgb(0, 0, 0, 35%);
  }
`;

export const TamanhoItem = styled(Grid).attrs({
  container: true,
})`
  margin-top: 15px;
  flex-direction: column;
  gap: 8px;
  flex-wrap: nowrap;

  &.parametro__tamanho {
    @media (max-width: 767px) {
      border: 2px solid #ddd;
      padding: 5px;
      border-radius: 5px;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }

  input[type='checkbox'] {
    width: 15px;
    height: 15px;
    margin: auto 5px auto 0px;
  }

  label {
    font-weight: bold;
    height: 15px;
  }

  .container__input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
  }

  .container__tamanho__input {
    display: flex;
    gap: 5px;

    div {
      flex: 1;
    }

    @media (min-width: 768px) {
      flex-direction: row;

      p {
        display: none;
      }
    }
  }

  .container__tamanho__button {
    display: flex;
    flex-direction: column;
    gap: 5px;

    @media (min-width: 500px) {
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }

    p {
      @media (min-width: 768px) {
        display: none;
      }
    }
  }
`;

export const DeleteTamanhoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border: none;
  background: none;
  outline: none;
  transition: all 0.2s;

  svg {
    color: #ea1d2c;
  }

  &:hover {
    opacity: 0.5;
  }
`;

export const NewTamanhoButton = styled.button`
  display: flex;
  align-items: center;
  margin: 15px 0 50px;
  border: none;
  outline: none;
  background: none;
  color: #2979ff;
  font-size: 1rem;

  svg {
    color: #2979ff;
    margin-right: 5px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const TamanhoInput = styled.input<{ type?: string }>`
  padding: 7px;
  border: 1px solid #757575;
  border-radius: 4px;

  width: 100%;

  &:out-of-range {
    background-color: rgba(255, 0, 0, 0.25);
    border: 1px solid red;
  }

  /* &.small__tamanho__input {

  } */
`;

export const TamanhoInputColor = styled.input<{ type?: string }>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border-radius: 5px;
  height: 31px;
  cursor: pointer;
  width: 100%;

  &::-webkit-color-swatch {
    border-radius: 5px;
    border: none;
  }

  &:out-of-range {
    background-color: rgba(255, 0, 0, 0.25);
    border: 1px solid red;
  }
`;

export const DrawerTitle = styled.div`
  margin: 2vh 0 2.5vh;

  h1 {
    margin-bottom: 2px;
    font-size: 24px;
    font-weight: 700;
    color: #212121;
  }

  span {
    display: block;
    margin-top: 12px;
    color: #757575;
  }

  &.titleDrawer_with_tabs {
    margin-top: 5px;
    margin-bottom: 10px;

    h1 {
      margin-bottom: -11px;
    }
  }
`;

export const AddNewGroup = styled.button`
  display: flex;
  align-items: center;

  padding: 20px;
  width: 90%;

  background: transparent;
  border-radius: 4px;
  border: 1px solid #e0e0e0;

  transition: all 0.35s ease-in-out;

  @media only screen and (max-width: 960px) {
    width: 100%;
  }

  img {
    height: 40px;
    width: 40px;

    margin-right: 25px;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    p {
      font-weight: 500;
      font-size: 14px;
      color: #212121;

      margin-bottom: 3px;
    }

    span {
      text-align: left;
      color: #616161;
    }
  }

  &:hover {
    background: #f5f5f5;
  }
`;

export const ImgInputWrapper = styled.div`
  position: relative;
  width: 140px;
  margin-top: 5px;
  margin-bottom: 15px;

  img {
    border-radius: 4px;
    width: 140px;
    height: 140px;

    border: 2px solid #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.35);
  }

  label {
    position: absolute;
    right: -17px;
    bottom: -4px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 42px;
    height: 42px;

    border-radius: 21px;
    border: none;
    color: #fefefe;
    background: #2979ff;
    cursor: pointer;

    transition: background 0.25s ease-in-out;

    &:hover {
      background: ${darken(0.075, '#2979ff')};
    }

    input {
      display: none;
    }
  }
`;

export const GrupoImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DrawerInputWrapper = styled.div`
  margin-bottom: -5px;

  > span:first-child {
    display: block;
    padding-left: 5px;
    margin-bottom: 7px;

    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
  }
`;

export const DrawerContainer = styled.div`
  width: 50vw;
  padding: 10px 15px;

  @media only screen and (max-width: 960px) {
    width: 75vw;
  }
`;

export const CloseButton = styled.button`
  width: 24px;
  height: 24px;

  margin: 15px 0 0 15px;
  background: transparent;
  border: none;
  color: #616161;

  transition: all 0.35s ease-in-out;

  &:hover {
    transform: scale(1.1);
    color: #d32f2f;
  }
`;

export const Informative = styled.span`
  font-size: 14px;
  color: #9e9e9e;

  > span {
    color: #f44336;
  }
`;

export const NewImg = styled.div`
  position: relative;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 15px;

  img {
    border-radius: 4px;
    width: 100%;
    height: auto;

    border: 2px solid #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.35);
  }

  label {
    position: absolute;
    right: -17px;
    bottom: -4px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 42px;
    height: 42px;

    border-radius: 21px;
    border: none;
    color: #fefefe;
    background: #2979ff;
    cursor: pointer;

    transition: background 0.25s ease-in-out;

    &:hover {
      background: ${darken(0.075, '#2979ff')};
    }

    input {
      display: none;
    }
  }
`;

export const TabWrapper = styled.div`
  padding: 20px 0 30px 0;
`;

export const LabelWrapper = styled.div`
  padding: 5px 5px;

  span {
    color: #212121;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const ButtonAction = styled(Button)`
  width: 110px;
  height: 35px;
  border-radius: 6px;
  margin: 0;

  font-size: 14px;

  transition: all 0.25s ease-in-out;

  &:disabled {
    border: 1px solid #757575;
    color: #757575;
    background: #f5f5f5 !important;
    cursor: not-allowed;
  }

  &.submit {
    background: #2962ff;

    &:hover {
      background: ${darken(0.1, '#2962ff')};
    }
  }

  &.cancel {
    background: #fff;
    border: 1px solid #c62828;
    margin-right: 15px;
    color: #c62828;

    &:hover {
      color: #fff;
      background: #c62828;
    }
  }
`;

export const DrawerTabTitle = styled.div`
  margin-bottom: 15px;

  h1 {
    font-size: 20px;
    font-weight: 500;
    color: #212121;
    margin-bottom: 3px;
  }

  span {
    font-size: 12px;
    color: #9e9e9e;
  }
`;

export const HasComplementoWrapper = styled.div`
  height: 120px;
  width: 100%;

  border-radius: 4px;

  background: url(${newProductIlustration}) no-repeat bottom;
  background-size: 100%;

  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);

  div {
    display: flex;
    flex-direction: column;

    padding: 20px 25px;
    width: 75vh;

    span {
      font-size: 14px;
      font-weight: 500;
      color: #212121;
      margin-bottom: 10px;
    }

    form {
      display: flex;
      flex-direction: column;

      label {
        input {
          margin-right: 5px;
        }

        display: flex;
        align-items: center;
        margin-bottom: 5px;

        font-size: 13px;
        color: #424242;
      }
    }
  }
`;

export const NewComplementoGrupo = styled(Button)`
  width: 250px;
  margin: 0;

  background: #fff;
  border: 1px solid #1565c0;
  color: #1565c0;
  font-size: 14px;
  border-radius: 6px;

  transition: all 0.25s ease-in-out;

  &:disabled {
    border: 1px solid #9e9e9e;
    color: #9e9e9e;
    cursor: not-allowed;
  }

  &:hover:enabled {
    color: #fff;
    background: #1565c0;
  }

  &:hover:disabled {
    border: 1px solid #757575;
    color: #757575;
  }
`;

export const RadioDisponibilidadeWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;

    div {
      margin-bottom: 12px;

      label {
        input {
          margin-right: 7px;
        }

        display: flex;
        align-items: center;
        margin-bottom: 2px;

        font-size: 15px;
        color: #212121;
      }

      span {
        margin-left: 1.5vw;
        color: #616161;
        font-size: 12px;
      }
    }
  }
`;

export const DisponibilidadeWrapper = styled.div<DisponibilidadeProps>`
  width: 100%;
  background-color: #eee;

  padding: 15px 20px;
  border-radius: 4px;

  ${(props) =>
    props.isInvisible &&
    css`
      display: none;
    `}

  div.dias {
    margin-bottom: 12px;

    span {
      display: block;
      font-size: 16px;
      font-weight: 400;
      color: #212121;
      margin-bottom: 10px;
    }

    input {
      display: none;
    }

    input[type='checkbox'] + label {
      display: inline-block;
      height: 30px;
      width: 30px;

      margin-right: 8px;
      border-radius: 15px;
      background: #fff;

      line-height: 30px;
      text-align: center;

      cursor: pointer;
    }

    input[type='checkbox']:checked + label {
      background: #1976d2;
      color: #fff;
    }
  }

  div.turno_wrapper {
    div.title_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      width: 60%;

      span {
        font-size: 15px;
        color: #212121;
      }
    }

    div.turnos_wrapper {
      margin-top: 5px;

      div.turno {
        display: flex;
        align-items: center;

        margin-top: 10px;

        > span {
          font-size: 15px;
          margin-right: 15px;
        }

        > button {
          border: none;
          background: transparent;
          color: #e53935;
          margin-left: 10px;
          transition: all 0.35s;

          &:hover {
            color: #d32f2f;
          }
        }
      }
    }
  }
`;

export const AddButton = styled.button`
  position: relative;

  border: none;
  background: none;

  font-size: 14px;
  font-weight: 500;
  color: #1976d2;

  transition: all 0.35s ease-in-out;

  &:hover {
    color: #1565c0;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;

    height: 1px;
    width: 0;

    background: #1565c0;

    transition: width 0.35s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const SelectTurno = styled(Select)`
  width: 120px;
  margin-right: 5px;
`;

export const OptionsWrapper = styled.div`
  div.title_wrapper {
    margin: 8px 0 12px;

    h1 {
      font-size: 16px;
      font-weight: 500;
      color: #212121;

      margin-bottom: 2px;
    }

    span {
      color: #757575;
      font-size: 13px;
    }
  }

  div.options_wrapper {
    display: flex;
    flex-direction: column;

    div {
      margin-bottom: 15px;

      label {
        input {
          margin-right: 7px;
        }

        display: flex;
        align-items: center;
        margin-bottom: 2px;

        font-size: 15px;
        color: #212121;
      }

      span {
        margin-left: 1.5vw;
        color: #616161;
        font-size: 12px;
      }
    }
  }
`;

export const Quantidade = styled.div<QuantidadeProps>`
  h1 {
    font-size: 16px;
    font-weight: 500;
    color: #212121;

    margin-bottom: 3px;
  }

  span.subtitle {
    display: block;
    font-size: 13px;
    color: #616161;
    margin-bottom: 15px;
  }

  div.wrapper {
    display: flex;
    align-items: center;

    div {
      margin-right: 10px;

      span {
        display: block;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 2px;
      }

      div.input_qtd {
        border: 1px solid #bdbdbd;
        border-radius: 4px;

        ${(props) =>
          props.isErrored &&
          css`
            border-color: #e53935;
          `}

        button {
          width: 25px;
          height: 25px;

          font-weight: 500;
          color: #1976d2;

          border: none;
          background: #fafafa;

          transition: all 0.35s ease-in-out;

          &:hover {
            background: ${darken(0.05, '#fafafa')};
          }
        }

        input {
          height: 25px;
          width: 30px;
          border: none;

          text-align: center;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }
`;

export const FormWrapper = styled.div`
  margin-bottom: 10px;
  padding: 5px 0;
`;

export const ComplementosStoredWrapper = styled.div`
  padding: 15px 10px;
  background: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.005);

  h2 {
    font-size: 14px;
    color: #212121;
  }
`;

export const AccordionWrapper = styled.div`
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.15);
`;

export const AccordionTitleWrapper = styled.div`
  h4 {
    font-weight: 300;
    font-size: 15px;
    color: #212121;
  }
`;

export const AccordionActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-weight: 300;
    font-size: 15px;
    font-style: italic;
  }
`;

export const ComplementoRowWrapper = styled.div`
  height: 42px;
  margin: 10px 0;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: calc(100% - 50px);
    height: 100%;

    margin-left: 25px;
    padding-left: 10px;
    border-left: 2px solid #e0e0e0;

    span {
      font-weight: 300;
      color: #212121;
      font-size: 14px;
    }
  }
`;

export const TrashBtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  height: 100%;

  button {
    background: transparent;

    border: none;
    color: #424242;
    margin-bottom: 7px;

    transition: all 0.35s ease-in-out;

    &:hover {
      color: #d32f2f;
    }
  }
`;

export const QtdItemContainer = styled.div`
  div.control-wrapper {
    span {
      display: block;
      font-size: 13px;
      margin-bottom: 8px;

      font-weight: 500;
      color: #212121;
    }

    input {
      width: 40px;
      height: 100%;
      text-align: center;
      border: none;
    }

    div {
      display: flex;
      align-items: center;

      height: 38px;
      border: 1px solid #bdbdbd;
      border-radius: 6px;

      button {
        height: 100%;
        width: 32%;

        background: #fafafa;

        font-weight: 500;
        font-size: 14px;
        color: #1976d2;
        border: none;

        &.decrement {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }

        &.increment {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex: 1;
  gap: 5px;

  div {
    flex: 1;
  }

  @media (min-width: 768px) {
    div {
      flex: initial;
      width: 105px;
    }
  }
`;

export const HeaderColumn = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  display: none;

  @media (min-width: 768px) {
    justify-content: flex-start;
    gap: 5px;
    display: flex;
  }

  p {
    width: initial;

    @media (min-width: 768px) {
      width: 195px;
      display: initial;
    }
  }
`;
